import type { FieldValues } from "react-hook-form";

function isPlainObject(value: unknown): value is Record<string, unknown> {
    return value != null && typeof value === "object" && !Array.isArray(value);
}

/**
 * Выбирает allowlist полей из значений формы.
 *
 * @param values значения формы
 * @param fields allowlist имён полей
 * @returns partial object для persist
 */
export function pickFormSubmissionMemoryFields<TFieldValues extends FieldValues>(
    values: TFieldValues,
    fields: readonly Extract<keyof TFieldValues, string>[] | undefined,
): Record<string, unknown> {
    if (fields == null) {
        return { ...values };
    }

    const picked: Record<string, unknown> = {};
    for (const fieldName of fields) {
        if (Object.prototype.hasOwnProperty.call(values, fieldName)) {
            picked[fieldName] = values[fieldName];
        }
    }

    return picked;
}

/**
 * Проверяет, что raw values из storage совместимы с allowlist.
 *
 * @param raw parsed values object
 * @param fields allowlist полей
 * @returns `true`, если объект можно безопасно восстановить
 */
export function isValidFormSubmissionMemoryValues(
    raw: unknown,
    fields: readonly string[] | undefined,
): raw is Record<string, unknown> {
    if (!isPlainObject(raw)) {
        return false;
    }

    if (fields == null) {
        return true;
    }

    for (const fieldName of fields) {
        if (!Object.prototype.hasOwnProperty.call(raw, fieldName)) {
            return false;
        }
    }

    return true;
}
